
import React, { useState, useEffect } from "react";
import { FaMapMarkerAlt, FaStar, FaUtensils, FaSearch, FaTimes, FaShoppingBag, FaTruck } from "react-icons/fa";
import { FaChair, FaConciergeBell } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Newnearbyresturent.css";
import ReelsSection from "./ReelsSection";
import Cateringcoustmize from './Cateringcoustmize'
import { FaUserTie } from "react-icons/fa";

const BASE_URL = "https://backend.maamaas.com/food";

const FALLBACK_BANNER =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200'%3E%3Crect width='300' height='200' fill='%23f5f5f5'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-size='15' fill='%23bbb' font-family='sans-serif'%3ENo Image%3C/text%3E%3C/svg%3E";

const FALLBACK_LOGO =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50'%3E%3Ccircle cx='25' cy='25' r='25' fill='%23ff4757'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-size='20' fill='white' font-family='sans-serif'%3ER%3C/text%3E%3C/svg%3E";

const RestaurantCards = ({ setShowLogin, setIsSignup, isLoggedIn }) => {
  const [cards, setCards] = useState([]);
  const [filteredCards, setFilteredCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [selectedType, setSelectedType] = useState("All");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [userLocation, setUserLocation] = useState(null);
  const [locationPermissionDenied, setLocationPermissionDenied] = useState(false);
  const [selectedOrderType, setSelectedOrderType] = useState(null);
  const [showOrderPopup, setShowOrderPopup] = useState(false);
  const [isPureVeg, setIsPureVeg] = useState(false);
  const [discountFilter, setDiscountFilter] = useState("Offers");
  const [couponFilter, setCouponFilter] = useState("Coupons");
  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [categoryVendorMap, setCategoryVendorMap] = useState({});
  const [cateringActiveTab, setCateringActiveTab] = useState("packages");
  const [cateringRestaurants, setCateringRestaurants] = useState([]);
  const [cateringLoading, setCateringLoading] = useState(false);
  const [cateringFilteredRestaurants, setCateringFilteredRestaurants] = useState([]);
  const [cateringSearch, setCateringSearch] = useState("");
  const [cateringSelectedType, setCateringSelectedType] = useState("All");
  const [cateringIsPureVeg, setCateringIsPureVeg] = useState(false);
  const [customizeForm, setCustomizeForm] = useState({
    name: "",
    email: "",
    phone: "",
    eventDate: "",
    eventType: "",
    guestCount: "",
    budget: "",
    cuisinePreferences: "",
    specialRequests: ""
  });
  const navigate = useNavigate();

  // Get userId from localStorage
  const getUserId = () => {
    return localStorage.getItem("userId") || "2";
  };

  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLat(position.coords.latitude);
        setLng(position.coords.longitude);
      },
      (error) => {
        console.error("Location error:", error);
      }
    );
  }, []);

  // Fetch catering restaurants
  const fetchCateringRestaurants = async () => {
    try {
      setCateringLoading(true);

      const response = await axios.get(
        `${BASE_URL}/api/user/nearby-vendors/get?latitude=${lat}&longitude=${lng}`,
        {
          headers: { "Content-Type": "application/json" }
        }
      );

      let vendors = [];

      if (Array.isArray(response.data)) {
        vendors = response.data;
      } else if (response.data?.data && Array.isArray(response.data.data)) {
        vendors = response.data.data;
      }

      const cateringVendors = vendors.filter(
        (vendor) =>
          vendor.orderTypes &&
          vendor.orderTypes.includes("CATERING")
      );

      const formattedCateringVendors = cateringVendors.map((vendor) => ({
        vendorId: vendor.vendorId || vendor.id,
        companyName:
          vendor.companyName ||
          vendor.registeredName ||
          "Restaurant",

        bannerUrl:
          vendor.companyBanner || FALLBACK_BANNER,

        logoUrl:
          vendor.companyLogo || FALLBACK_LOGO,

        city:
          vendor.city || "Location not specified",

        ratings:
          vendor.ratings || vendor.avgRating || null,

        addressLine:
          vendor.fullAddress ||
          vendor.addressLine ||
          "Address not available",

        orderTypes:
          vendor.orderTypes || [],

        Type:
          vendor.type || "RESTAURANT",

        isPureVeg:
          vendor.isPureVeg ||
          vendor.pureVeg ||
          false
      }));

      setCateringRestaurants(formattedCateringVendors);
      setCateringFilteredRestaurants(formattedCateringVendors);

    } catch (err) {
      console.error(
        "Error fetching catering restaurants:",
        err
      );
    } finally {
      setCateringLoading(false);
    }
  };

  // Filter catering restaurants
  useEffect(() => {
    if (selectedOrderType === "CATERING" && cateringRestaurants.length > 0) {
      let result = [...cateringRestaurants];

      if (cateringSearch) {
        const searchTerm = cateringSearch.toLowerCase();
        result = result.filter(r =>
          r.companyName?.toLowerCase().includes(searchTerm) ||
          r.addressLine?.toLowerCase().includes(searchTerm)
        );
      }

      if (cateringSelectedType !== "All") {
        result = result.filter(r => r.Type === cateringSelectedType);
      }

      if (cateringIsPureVeg) {
        result = result.filter(r => r.isPureVeg === true);
      }

      setCateringFilteredRestaurants(result);
    }
  }, [cateringSearch, cateringSelectedType, cateringIsPureVeg, cateringRestaurants, selectedOrderType]);

  // ── Fetch Categories with Vendor Mapping from API ──────────────────────────
  const fetchCategoriesWithVendors = async () => {
    try {
      setCategoriesLoading(true);
      const userId = getUserId();
      const response = await axios.get(`${BASE_URL}/api/dish/dish/getall/categeory?userId=${userId}`, {
        headers: { "Content-Type": "application/json" }
      });



      let categoriesData = [];
      let vendorMap = {};

      if (Array.isArray(response.data)) {
        categoriesData = response.data;
      } else if (response.data?.data && Array.isArray(response.data.data)) {
        categoriesData = response.data.data;
      } else if (response.data?.categories && Array.isArray(response.data.categories)) {
        categoriesData = response.data.categories;
      }

      const uniqueCategories = new Map();

      categoriesData.forEach(item => {
        const categoryName = item.categoryName;
        const vendorIds = item.vendorIds || [];
        const image = item.image;

        if (!uniqueCategories.has(categoryName)) {
          uniqueCategories.set(categoryName, {
            categoryName: categoryName,
            image: image,
            vendorIds: [...vendorIds]
          });
        } else {
          const existing = uniqueCategories.get(categoryName);
          const mergedVendors = [...new Set([...existing.vendorIds, ...vendorIds])];
          uniqueCategories.set(categoryName, {
            ...existing,
            vendorIds: mergedVendors
          });
        }
      });

      const allCategory = {
        categoryName: "All",
        image: "https://cdn-icons-png.flaticon.com/512/1046/1046784.png",
        vendorIds: []
      };

      const formattedCategories = [allCategory];

      for (const [name, data] of uniqueCategories.entries()) {
        formattedCategories.push({
          categoryName: name,
          image: data.image,
          vendorIds: data.vendorIds
        });
        vendorMap[name] = data.vendorIds;
      }

      setCategories(formattedCategories);
      setCategoryVendorMap(vendorMap);


    } catch (err) {
      console.error("Error fetching category-dish API:", err);
      setCategories([
        { categoryName: "All", image: "https://cdn-icons-png.flaticon.com/512/1046/1046784.png", vendorIds: [] },
        { categoryName: "Biryani", image: "https://cdn-icons-png.flaticon.com/512/3075/3075977.png", vendorIds: [] },
        { categoryName: "Tiffins", image: "https://cdn-icons-png.flaticon.com/512/3075/3075977.png", vendorIds: [] },
        { categoryName: "Veg", image: "https://cdn-icons-png.flaticon.com/512/1046/1046784.png", vendorIds: [] },
      ]);
    } finally {
      setCategoriesLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchCategoriesWithVendors();
  }, []);

  useEffect(() => {
    if (selectedOrderType === "CATERING") {
      fetchCateringRestaurants();
    }
  }, [selectedOrderType]);

  const getUserLocation = () =>
    new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Geolocation not supported by your browser"));
        return;
      }
      navigator.geolocation.getCurrentPosition(
        (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
        (err) => {
          console.error("Geolocation error:", err);
          if (err.code === 1) {
            reject(new Error("Location permission denied. Please enable location access."));
          } else if (err.code === 2) {
            reject(new Error("Location unavailable. Please try again."));
          } else {
            reject(new Error("Unable to get your location. Please check your settings."));
          }
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
      );
    });

  const normaliseVendor = (vendor, userLoc = null) => {
    let bannerUrl = FALLBACK_BANNER;
    if (vendor.companyBanner && typeof vendor.companyBanner === 'string' && vendor.companyBanner.trim()) {
      bannerUrl = vendor.companyBanner;
    } else if (vendor.bannerUrl && vendor.bannerUrl.trim()) {
      bannerUrl = vendor.bannerUrl;
    }

    let logoUrl = FALLBACK_LOGO;
    if (vendor.companyLogo && typeof vendor.companyLogo === 'string' && vendor.companyLogo.trim()) {
      logoUrl = vendor.companyLogo;
    } else if (vendor.logoUrl && vendor.logoUrl.trim()) {
      logoUrl = vendor.logoUrl;
    }

    let distanceLabel = "N/A";
    let distanceValue = null;
    if (vendor.distance != null && !isNaN(vendor.distance)) {
      distanceValue = parseFloat(vendor.distance);
      distanceLabel = `${distanceValue.toFixed(1)} km`;
    }

    let ratings = "New";
    let ratingValue = null;
    if (vendor.ratings && typeof vendor.ratings === 'number' && vendor.ratings > 0) {
      ratingValue = vendor.ratings;
      ratings = ratingValue.toFixed(1);
    } else if (vendor.avgRating && typeof vendor.avgRating === 'number' && vendor.avgRating > 0) {
      ratingValue = vendor.avgRating;
      ratings = ratingValue.toFixed(1);
    }

    const vendorType = vendor.type || vendor.vendorType || "RESTAURANT";
    const displayType = vendorType.charAt(0).toUpperCase() + vendorType.slice(1).toLowerCase();
    const address = vendor.fullAddress || vendor.addressLine || "Location not available";
    const city = vendor.city || "Hyderabad";

    return {
      vendorId: vendor.vendorId || vendor.id || vendor._id,
      bannerUrl,
      logoUrl,
      companyName: vendor.companyName || vendor.registeredName || vendor.name || "Restaurant",
      position: vendor.position || null,
      Type: displayType,
      category: vendor.category || displayType,
      addressLine: address,
      city: city,
      ratings: ratings,
      ratingValue: ratingValue,
      distance: distanceLabel,
      distanceValue: distanceValue,
      latitude: vendor.latitude,
      longitude: vendor.longitude,
      orderTypes: vendor.orderTypes || [],
      restaurantStatus: vendor.restaurantStatus !== false,
      startTime: vendor.startTime,
      lastTime: vendor.lastTime,
      establishedYear: vendor.establishedYear,
      isOpen: vendor.restaurantStatus === true,
      isPureVeg: vendor.isPureVeg || vendor.pureVeg || false,
      cuisineTypes: vendor.cuisineTypes || []
    };
  };

  const extractVendors = (data) => {
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.data)) return data.data;
    if (Array.isArray(data?.vendors)) return data.vendors;
    if (Array.isArray(data?.nearbyVendors)) return data.nearbyVendors;
    if (Array.isArray(data?.results)) return data.results;
    return [];
  };

  const fetchNearbyRestaurants = async () => {
    try {
      setLoading(true);
      setError("");
      setLocationPermissionDenied(false);

      let userLoc;
      try {
        userLoc = await getUserLocation();
        setUserLocation(userLoc);

      } catch (locErr) {

        setLocationPermissionDenied(true);
        setError(locErr.message || "Unable to get your location. Please enable location access.");
        setLoading(false);
        return;
      }

      const { lat, lng } = userLoc;
      const API_URL = `${BASE_URL}/api/user/nearby-vendors/get?latitude=${lat}&longitude=${lng}`;
      console.log("Nearby API URL:", API_URL);

      const response = await axios.get(API_URL, {
        headers: {
          "Content-Type": "application/json",
        },
      });



      let vendors = extractVendors(response.data);

      if (Array.isArray(response.data)) {
        vendors = response.data;
      }



      if (!vendors || vendors.length === 0) {
        setError("No restaurants found near your location. Try expanding your search area.");
        setCards([]);
        setFilteredCards([]);
        return;
      }

      const formatted = vendors
        .map((v) => normaliseVendor(v, userLoc))
        .filter(v => v.restaurantStatus === true)
        .sort((a, b) => {
          const distA = a.distanceValue !== null ? a.distanceValue : Infinity;
          const distB = b.distanceValue !== null ? b.distanceValue : Infinity;
          return distA - distB;
        });


      setCards(formatted);
      setFilteredCards(formatted);

    } catch (err) {


      let errorMessage = "Unable to load nearby restaurants. ";
      if (err.response?.status === 404) {
        errorMessage += "Nearby vendors endpoint not found.";
      } else if (err.response?.status === 500) {
        errorMessage += "Server error. Please try again later.";
      } else if (err.code === "ERR_NETWORK") {
        errorMessage += "Network error. Please check your connection.";
      } else if (err.response?.data?.message) {
        errorMessage += err.response.data.message;
      } else {
        errorMessage += "Please try again.";
      }

      setError(errorMessage);
      setCards([]);
      setFilteredCards([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNearbyRestaurants();
  }, []);

  useEffect(() => {
    if (selectedOrderType === "CATERING") {
      return;
    }

    let result = [...cards];

    if (search) {
      const searchTerm = search.toLowerCase();
      result = result.filter(
        (c) =>
          c.companyName?.toLowerCase().includes(searchTerm) ||
          c.city?.toLowerCase().includes(searchTerm) ||
          c.Type?.toLowerCase().includes(searchTerm) ||
          c.addressLine?.toLowerCase().includes(searchTerm) ||
          (c.cuisineTypes && c.cuisineTypes.some(ct => ct.toLowerCase().includes(searchTerm)))
      );
    }

    if (selectedType !== "All") {
      result = result.filter((c) => c.Type === selectedType);
    }

    if (selectedCategory !== "All" && categoryVendorMap[selectedCategory]) {
      const allowedVendorIds = categoryVendorMap[selectedCategory];
      result = result.filter((c) => allowedVendorIds.includes(Number(c.vendorId)));
    }

    if (selectedOrderType && selectedOrderType !== "CATERING") {
      result = result.filter((c) => {
        return c.orderTypes && Array.isArray(c.orderTypes) &&
          c.orderTypes.includes(selectedOrderType);
      });
    }

    if (isPureVeg) {
      result = result.filter((c) => c.isPureVeg === true);
    }

    setFilteredCards(result);
  }, [search, selectedType, cards, selectedOrderType, isPureVeg, selectedCategory, categoryVendorMap]);

  const handleOrderTypeSelect = (orderType) => {
    setSelectedOrderType(orderType);
    localStorage.setItem("selectedOrderType", orderType);

    if (orderType === "CATERING") {
      setCateringActiveTab("packages");
      setCateringSearch("");
      setCateringSelectedType("All");
      setCateringIsPureVeg(false);
    }
  };

  const handleCustomizeInputChange = (e) => {
    const { name, value } = e.target;
    setCustomizeForm(prev => ({ ...prev, [name]: value }));
  };

  const handleCustomizeSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("authToken");
      const userId = localStorage.getItem("userId");

      if (!token || !userId) {
        alert("Please login to submit catering request");
        return;
      }

      const response = await axios.post(`${BASE_URL}/api/catering/request`, {
        ...customizeForm,
        userId: userId,
        orderType: "CATERING"
      }, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
      });

      if (response.data?.success || response.status === 200) {
        alert("Catering request submitted successfully! We'll contact you soon.");
        setCustomizeForm({
          name: "",
          email: "",
          phone: "",
          eventDate: "",
          eventType: "",
          guestCount: "",
          budget: "",
          cuisinePreferences: "",
          specialRequests: ""
        });
      }
    } catch (err) {

      alert("Failed to submit request. Please try again.");
    }
  };

  const setOrderTypeToApi = async (vendorId, orderType) => {
    try {
      const token = localStorage.getItem("authToken");
      const userId = localStorage.getItem("userId");

      if (!token || !userId) return false;

      const url = `${BASE_URL}/api/cart/create/cart/orderType?userId=${userId}&orderType=${orderType}`;


      const res = await axios.post(url, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });



      if (res.data?.success || res.status === 200) {
        localStorage.setItem("orderType", orderType);
        return true;
      }
      return false;
    } catch (err) {

      localStorage.setItem("orderType", orderType);
      return true;
    }
  };

  const handleCardClick = async (vendorId) => {
    if (!selectedOrderType) {
      setShowOrderPopup(true);
      setTimeout(() => {
        setShowOrderPopup(false);
      }, 2500);
      return;
    }

    if (!vendorId) return;

    const loggedIn = isLoggedIn || localStorage.getItem("isLoggedIn") === "true";
    if (!loggedIn) {
      setIsSignup(false);
      setShowLogin(true);
      return;
    }

    await setOrderTypeToApi(vendorId, selectedOrderType);

    localStorage.setItem("vendorId", vendorId);
    localStorage.setItem("orderType", selectedOrderType);

    if (selectedOrderType === "TABLE_DINE_IN") {
      navigate(`/MenuitemsTablemain/${vendorId}`, {
        state: { orderType: selectedOrderType, vendorId: vendorId }
      });
    } else if (selectedOrderType === "CATERING") {
      navigate(`/cateringmenu/${vendorId}`, {
        state: { orderType: selectedOrderType, vendorId: vendorId }
      });
    } else {
      navigate(`/Tablemainfile/${vendorId}`, {
        state: { orderType: selectedOrderType, vendorId: vendorId }
      });
    }
  };

  const handleCategoryClick = (categoryName) => {
    setSelectedCategory(categoryName);
  };

  const getUniqueTypes = () => {
    const types = new Set(cards.map(card => card.Type));
    return ["All", ...Array.from(types).sort()];
  };

  const getCateringUniqueTypes = () => {
    const types = new Set(cateringRestaurants.map(r => r.Type));
    return ["All", ...Array.from(types).sort()];
  };

  const handleRetry = () => {
    if (locationPermissionDenied) {
      alert("Please enable location access in your browser settings, then click OK to try again.");
    }
    fetchNearbyRestaurants();
  };

  const clearAllFilters = () => {
    setSearch("");
    setSelectedType("All");
    setSelectedCategory("All");
    setSelectedOrderType(null);
    setIsPureVeg(false);
    setDiscountFilter("Offers");
    setCouponFilter("Coupons");
    localStorage.removeItem("selectedOrderType");
    setCateringActiveTab("packages");
    setCateringSearch("");
    setCateringSelectedType("All");
    setCateringIsPureVeg(false);
  };

  const clearCateringFilters = () => {
    setCateringSearch("");
    setCateringSelectedType("All");
    setCateringIsPureVeg(false);
  };

  const renderCateringContent = () => {
    return (
      <div className="catering-content-wrapper">
        {/* Catering Filters */}
        {/* <div className="catering-filters-section">
          <div className="catering-filter-left">
            <div className="filter-box">Catering Filters</div>
            {(cateringSearch || cateringSelectedType !== "All" || cateringIsPureVeg) && (
              <button className="rc-clear-btn premium-clear" onClick={clearCateringFilters}>
                ✖ Clear Filters
              </button>
            )}
          </div>
          <div className="catering-filter-right">
            <select 
              className="rc-select premium-select" 
              value={cateringSelectedType} 
              onChange={(e) => setCateringSelectedType(e.target.value)}
            >
              {getCateringUniqueTypes().map((type) => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
            <button 
              className={`pure-veg-toggle premium-veg ${cateringIsPureVeg ? "active" : ""}`} 
              onClick={() => setCateringIsPureVeg(!cateringIsPureVeg)}
            >
              🌱 {cateringIsPureVeg ? "Veg-On" : "Veg"}
            </button>
            <div className="rc-search-wrap search-right">
              <FaSearch className="rc-search-icon" />
              <input 
                type="text" 
                placeholder="Search catering restaurants..." 
                className="rc-search" 
                value={cateringSearch} 
                onChange={(e) => setCateringSearch(e.target.value)} 
              />
              {cateringSearch && <FaTimes className="rc-clear-icon" onClick={() => setCateringSearch("")} />}
            </div>
          </div>
        </div> */}

        {/* Catering Tabs */}
        <div className="catering-tabs">
          <button
            className={`catering-tab ${cateringActiveTab === "packages" ? "active" : ""}`}
            onClick={() => setCateringActiveTab("packages")}
          >
            📦 Packages
          </button>
          <button
            className={`catering-tab ${cateringActiveTab === "customize" ? "active" : ""}`}
            onClick={() => setCateringActiveTab("customize")}
          >
            🎨 Customize Menu
          </button>
        </div>

        <div className="catering-tab-content">
          {cateringActiveTab === "packages" && (
            <div className="catering-packages">
              {cateringLoading ? (
                <div className="rc-state">
                  <div className="rc-spinner" />
                  <p>Loading catering restaurants...</p>
                </div>
              ) : cateringFilteredRestaurants.length === 0 ? (
                <div className="rc-state">
                  <p>No catering restaurants found</p>
                  {(cateringSearch || cateringSelectedType !== "All" || cateringIsPureVeg) && (
                    <button className="rc-retry-btn" onClick={clearCateringFilters} style={{ marginTop: "12px", background: "#666" }}>
                      Clear Filters
                    </button>
                  )}
                </div>
              ) : (
                <div className="catering-restaurants-grid">
                  {cateringFilteredRestaurants.map(restaurant => (
                    <div
                      key={restaurant.vendorId}
                      className="catering-restaurant-card"
                      onClick={() => handleCardClick(restaurant.vendorId)}
                    >
                      <div className="catering-card-banner">
                        <img
                          src={restaurant.bannerUrl}
                          alt={restaurant.companyName}
                          onError={(e) => e.target.src = FALLBACK_BANNER}
                        />
                        {/* <img 
                          src={restaurant.logoUrl} 
                          alt="logo" 
                          className="catering-card-logo"
                          onError={(e) => e.target.src = FALLBACK_LOGO}
                        /> */}
                        {restaurant.isPureVeg && (
                          <div className="catering-veg-badge">🌱 PURE VEG</div>
                        )}
                      </div>
                      <div className="catering-restaurant-info">
                        <h4>{restaurant.companyName}</h4>
                        <p className="catering-address">
                          <FaMapMarkerAlt className="icon-small" /> {restaurant.addressLine}
                        </p>
                        {restaurant.ratings && (
                          <div className="rating">
                            <FaStar className="star" /> {restaurant.ratings}
                          </div>
                        )}
                        <button className="view-packages-btn">
                          View Packages
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {cateringActiveTab === "customize" && (
            <div className="catering-customize">
              <Cateringcoustmize />
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="rc-wrapper">


      <div className="rc-main-layout">
        <div className="rc-left">

          <div className="rc-filters premium-filters">
            <div className="filter-left">
              <div className="filter-box">Filters</div>
              {(search || selectedType !== "All" || selectedCategory !== "All" || selectedOrderType || isPureVeg || discountFilter !== "Offers" || couponFilter !== "Coupons") && (
                <button className="rc-clear-btn premium-clear" onClick={clearAllFilters}>✖ Clear Filters</button>
              )}
            </div>
            <div className="filter-right">
              <select className="rc-select premium-select" value={discountFilter} onChange={(e) => setDiscountFilter(e.target.value)}>
                <option value="Offers">Offers</option>
                <option value="10% OFF">10% OFF</option>
                <option value="20% OFF">20% OFF</option>
                <option value="30% OFF">30% OFF</option>
                <option value="50% OFF">50% OFF</option>
              </select>
              <select className="rc-select premium-select" value={couponFilter} onChange={(e) => setCouponFilter(e.target.value)}>
                <option value="Coupons">Coupons</option>
                <option value="FREEDEL">FREEDEL</option>
                <option value="SAVE20">SAVE20</option>
                <option value="WELCOME50">WELCOME50</option>
              </select>
              <select className="rc-select premium-select" value={selectedType} onChange={(e) => setSelectedType(e.target.value)}>
                {getUniqueTypes().map((type) => (<option key={type} value={type}>{type}</option>))}
              </select>
              <button className={`pure-veg-toggle premium-veg ${isPureVeg ? "active" : ""}`} onClick={() => setIsPureVeg(!isPureVeg)}>
                🌱 {isPureVeg ? "Veg-On" : "Veg"}
              </button>
              <div className="rc-search-wrap search-right">
                <FaSearch className="rc-search-icon" />
                <input type="text" placeholder="Search restaurants..." className="rc-search" value={search} onChange={(e) => setSearch(e.target.value)} />
                {search && (<FaTimes className="rc-clear-icon" onClick={() => setSearch("")} />)}
              </div>
            </div>
          </div>

          {/* Categories Section - Always visible */}
          <div
  style={{
    marginBottom: "20px",
    padding: "0 12px",
    position: "sticky",
    top: "70px",
    zIndex: 999,
    background: "#fff",
  }}
>
  <h3
    style={{
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "12px",
      color: "#333",
    }}
  >
    Explore Categories
  </h3>

  {categoriesLoading ? (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <div
        style={{
          width: "20px",
          height: "20px",
          border: "2px solid #f3f3f3",
          borderTop: "2px solid #ee6521",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      ></div>
      <span>Loading categories...</span>
    </div>
  ) : (
    <div
      style={{
        display: "flex",
        overflowX: "auto",
        gap: "14px",
        paddingBottom: "8px",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      {categories.map((cat) => (
        <div
          key={cat.categoryName}
          onClick={() => handleCategoryClick(cat.categoryName)}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minWidth: "72px",
            maxWidth: "72px",
            cursor: "pointer",
            flexShrink: 0,
          }}
        >
          <div
            style={{
              width: "56px",
              height: "56px",
              borderRadius: "50%",
              overflow: "hidden",
              background: "#fff",
              border:
                selectedCategory === cat.categoryName
                  ? "2px solid #ee6521"
                  : "2px solid #ddd",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              marginBottom: "8px",
            }}
          >
            <img
              src={cat.image}
              alt={cat.categoryName}
              onError={(e) => {
                e.target.src =
                  "https://cdn-icons-png.flaticon.com/512/1046/1046784.png";
              }}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </div>

          <p
            title={cat.categoryName}
            style={{
              width: "100%",
              margin: 0,
              fontSize: "12px",
              fontWeight:
                selectedCategory === cat.categoryName ? "600" : "400",
              color:
                selectedCategory === cat.categoryName
                  ? "#ee6521"
                  : "#333",
              textAlign: "center",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              lineHeight: "16px",
            }}
          >
            {cat.categoryName}
          </p>
        </div>
      ))}
    </div>
  )}

  <style>{`
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    div::-webkit-scrollbar {
      display: none;
    }
  `}</style>
</div>

          {/* Order Type Section */}
          <div className="rc-order-type-section">
            <div className="rc-order-buttons">
              <button className={`rc-order-btn ${selectedOrderType === "DINE_IN" ? "active" : ""}`} onClick={() => handleOrderTypeSelect("DINE_IN")}>
                <FaUtensils className="rc-order-icon" /> Dine In
              </button>
              <button className={`rc-order-btn ${selectedOrderType === "TAKEAWAY" ? "active" : ""}`} onClick={() => handleOrderTypeSelect("TAKEAWAY")}>
                <FaShoppingBag className="rc-order-icon" /> Take Away
              </button>
              <button className={`rc-order-btn ${selectedOrderType === "DELIVERY" ? "active" : ""}`} onClick={() => handleOrderTypeSelect("DELIVERY")}>
                <FaTruck className="rc-order-icon" /> Delivery
              </button>
              <button className={`rc-order-btn ${selectedOrderType === "TABLE_DINE_IN" ? "active" : ""}`} onClick={() => handleOrderTypeSelect("TABLE_DINE_IN")}>
                <FaChair className="rc-order-icon" /> Dine Out
              </button>
              <button className={`rc-order-btn ${selectedOrderType === "CATERING" ? "active" : ""}`} onClick={() => handleOrderTypeSelect("CATERING")}>
                <FaConciergeBell className="rc-order-icon" /> Catering
              </button>
            </div>

          </div>

          {/* Content Area */}
          {selectedOrderType === "CATERING" ? (
            renderCateringContent()
          ) : (
            <>
              {isPureVeg && filteredCards.length > 0 && (<div className="veg-filter-message">🌱 Showing {filteredCards.length} pure vegetarian restaurant(s)</div>)}
              {selectedCategory !== "All" && filteredCards.length > 0 && (<div className="category-filter-message">🍽️ Showing {filteredCards.length} restaurant(s) in "{selectedCategory}" category</div>)}

              <div className="rc-grid-wrap">

                {showOrderPopup && (
                  <div className="rc-order-popup">
                    <span className="rc-popup-icon">⚠️</span>
                    Please select order type first
                  </div>
                )}

                {loading ? (
                  <div className="rc-state"><div className="rc-spinner" /><p>Finding restaurants near you...</p><p className="rc-state-small">Getting your location and discovering nearby places</p></div>
                ) : error ? (
                  <div className="rc-state"><p className="rc-error">{error}</p><button className="rc-retry-btn" onClick={handleRetry}><FaMapMarkerAlt style={{ marginRight: 8 }} />Try Again with Location</button>{locationPermissionDenied && (<p className="rc-help-text">Tip: Click the location icon in your browser address bar to enable access</p>)}</div>
                ) : filteredCards.length === 0 ? (
                  <div className="rc-state"><p>No restaurants found</p>{(selectedOrderType || selectedCategory !== "All" || isPureVeg || search) && (<button className="rc-retry-btn" onClick={clearAllFilters} style={{ marginTop: "12px", background: "#666" }}>Clear All Filters</button>)}</div>
                ) : (
                  <div className="rc-grid">
                    {filteredCards.map((card) => (
                      <div key={card.vendorId} className="rc-card" onClick={() => handleCardClick(card.vendorId)}>
                        <div className="rc-banner-wrap">
                          <img src={card.bannerUrl} alt={card.companyName} className="rc-banner" onError={(e) => { if (e.target.src !== FALLBACK_BANNER) e.target.src = FALLBACK_BANNER; }} />
                          <img src={card.logoUrl} alt="logo" className="rc-logo" onError={(e) => { if (e.target.src !== FALLBACK_LOGO) e.target.src = FALLBACK_LOGO; }} />
                          {!card.restaurantStatus && (<div className="rc-closed-badge">Closed</div>)}
                          {card.isPureVeg && (<div className="pure-veg-badge">🌱 PURE VEG</div>)}
                        </div>

                        <div className="rc-body">


                          {/* Row 1: Company + Type + Rating */}
                          <div className="rc-row-top">
                            <h4 className="rc-name" title={card.companyName}>
                              {card.companyName}
                            </h4>

                            <p className="rc-type">
                              <FaUtensils className="rc-icon-red" />
                              &nbsp;{card.Type}
                            </p>

                            <div className="rc-rating">
                              <FaStar className="rc-star" />&nbsp;{card.ratings}
                            </div>
                          </div>

                          {/* Row 2: Position (above address) */}
                          {card.position && (
                            <p className="rc-position">
                              <FaUserTie className="rc-position-icon" />
                              <span className="rc-position-text">
                                {card.position.toLowerCase()}
                              </span>
                            </p>
                          )}

                          {/* Row 3: Address + Distance */}
                          <div className="rc-location-row">
                            <span className="rc-address" title={card.addressLine}>
                              <FaMapMarkerAlt className="rc-icon-red" />
                              &nbsp;
                              {card.addressLine?.length > 30
                                ? card.addressLine.substring(0, 30) + "…"
                                : card.addressLine}
                            </span>

                            <span className="rc-distance">📍 {card.distance}</span>
                          </div>

                          {/* Timing */}
                          {card.startTime && card.lastTime && (
                            <div className="rc-timing">
                              ⏰ {card.startTime.slice(0, 5)} - {card.lastTime.slice(0, 5)}
                            </div>
                          )}

                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          )}
        </div>

        <div className="rc-right" style={{ marginTop: '40px' }}>
          <ReelsSection />
        </div>
      </div>
    </div>
  );
};

export default RestaurantCards;